import { useQuery } from '@tanstack/react-query';
import { getDocumentCommentLog } from 'services/api/dynamicFormsApi';

/**
 * `throwOnError` decides what a failed request does. On the comment log page the log is the whole
 * point, so throwing to the error boundary beats rendering "No comments found" over an error. In
 * the document action bar the log is a secondary affordance, and a failure there must not take the
 * bar down with it - the button simply does not appear.
 */
export const useDocumentCommentLog = (docId: string, enabled: boolean, throwOnError = false) =>
  useQuery({
    queryKey: ['DOC_COMMENT_LOG', docId],
    queryFn: () => getDocumentCommentLog(docId),
    enabled: enabled && !!docId,
    staleTime: 0,
    refetchOnMount: 'always',
    throwOnError,
  });
